import { type DocumentView } from '@heidi/session/contracts';

import { type DocumentResponse } from '.';
import { Brain, DocumentTabType } from './schema';

export const mockEmptyDocument: DocumentResponse = {
  id: 'empty-document',
  session_id: 'session-id',
  creator_kinde_id: 'creator-kinde-id',
  index: 0,
  name: 'Untitled Document',
  template_id: null,
  ai_command_id: null,
  question: null,
  content: null,
  updated_dictation: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  deleted_at: null,
  brain: Brain.LEFT,
  document_tab_type: DocumentTabType.DOCUMENT,
};

export const mockEmptyDocumentView: DocumentView = {
  id: 'empty-document',
  session_id: 'session-id',
  creator_kinde_id: 'creator-kinde-id',
  index: 0,
  name: 'Untitled Document',
  template_id: null,
  ai_command_id: null,
  question: null,
  content: null,
  updated_dictation: null,
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
  deleted_at: null,
  brain: Brain.LEFT,
  document_tab_type: DocumentTabType.DOCUMENT,
};
